import { SLOTS } from './slots.js'

// User moments (photo/video posts). Image-heavy, so grid is the default view; table
// remains available via the view switcher. The page passes a per-tab emptyMessage.
export default {
  key: 'moment',
  label: 'Moment',
  icon: 'moments',
  columns: [
    {
      slot: SLOTS.PRIMARY,
      label: 'User',
      field: 'user.icon_image.image_url',
      renderer: 'avatar',
      labelField: 'user_label',
      link: 'user.url'
    },
    { slot: SLOTS.CONTEXT, label: 'Place', field: 'place_label', link: 'place.url' },
    // `cardMedia` makes this (not the poster's avatar) the grid card's image.
    { slot: SLOTS.METADATA, label: 'Media', field: 'media', renderer: 'moment_media', cardMedia: true },
    { slot: SLOTS.METADATA, label: 'Hypes', field: 'hypes_count', renderer: 'points', align: 'right' },
    {
      slot: SLOTS.STATUS,
      label: 'Status',
      field: 'moderation_state',
      renderer: 'state_badge',
      domain: 'moderation',
      labelField: 'moderation_label'
    },
    { slot: SLOTS.STATUS, label: 'Visibility', field: 'visibility', renderer: 'state_badge', domain: 'visibility' },
    { slot: SLOTS.STATUS, label: 'Reports', field: 'moment_reports', renderer: 'report_summary' },
    { slot: SLOTS.TEMPORAL, field: 'created_at', label: 'Created', renderer: 'date' }
  ],
  empty: { icon: 'moments', message: 'No moments found.' },
  defaultView: 'grid',
  grid: { show: [SLOTS.PRIMARY, SLOTS.CONTEXT, SLOTS.METADATA, SLOTS.STATUS, SLOTS.TEMPORAL], columns: 4 },
  compact: { show: [SLOTS.PRIMARY, SLOTS.STATUS] }
}
